import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BottomSheetPlanOverviewState {
  sheetDisplay: boolean;
}

const initialState: BottomSheetPlanOverviewState = {
  sheetDisplay: false,
}

const bottomSheetPlanSlice = createSlice({
  name: 'MLTC-R3-PlanModalSheet',
  initialState,
  reducers: {
    updateSheetDisplay: (state, action: PayloadAction<boolean>) => {
      state.sheetDisplay = action.payload;
    }
  },
  extraReducers: {}
})

export const { updateSheetDisplay } = bottomSheetPlanSlice.actions;

export default bottomSheetPlanSlice.reducer;